<form [formGroup]="form">
  <ng-container *ngIf="!design_pattern || design_pattern == 1">
    <mat-form-field floatLabel="always" [ngClass]="{'label-overflow':label_overflow,'no-label':hide_label}">
      <mat-label *ngIf="!required && !hide_label" [innerHtml]="label| HTMLFormatter"></mat-label>
      <mat-label *ngIf="required && !hide_label" [innerHtml]="label| HTMLFormatter"></mat-label>
      <input matInput [formControlName]="controlName" class="d-none">
      <input style="cursor:auto;" (click)="openPicker(1)" matInput [matDatetimepickerT2]="picker" [formControl]="date"
        [min]="minValue" [max]="maxValue" [placeholder]="placeholder" autocomplete="false"
        (dateChange)="addEvent($event)" [readonly]="disabled" [name]="random_id">
      <span class="pointer"
        *ngIf="form && form.get(controlName) && form.get(controlName).value && !required && !disabled"
        style="position: absolute; right: 0;" (click)="removeDate($event)">
        <i class="fa fa-times"></i>
      </span>
      <span *ngIf="suffix_settings" [ngClass]="{'pointer':suffix_settings.func}" matSuffix class="mx-2"
        [matTooltip]="suffix_settings.title" (click)="suffix_settings.func?'':''"> <i
          class="fa {{suffix_settings.icon ||'fa-level-up'}}" aria-hidden="true"></i> </span>
      <mat-error *ngIf="form.get([controlName]).hasError('required');else maxvalue">
        Field is mandatory
        <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
      </mat-error>
      <ng-template #maxvalue>
        <mat-error *ngIf="form.get([controlName]).hasError('matDatepickerMax');else minvalue">
          Value must be lesser than {{maxValue | date: 'd-MMM-yyyy h:mm a'}}
        </mat-error>
      </ng-template>
      <ng-template #minvalue>
        <mat-error *ngIf="form.get([controlName]).hasError('matDatepickerMin')">
          Value must be greater than {{minValue | date: 'd-MMM-yyyy h:mm a'}}
        </mat-error>
      </ng-template>
      <mat-datetimepickerT2-toggle matSuffix [for]="picker" [hidden]="disabled"></mat-datetimepickerT2-toggle>
      <mat-datetimepickerT2 #picker [multiYearSelector]="true" [twelvehour]="true" timeInterval="5" mode="portrait"
        disabled="false" [hidden]="disabled" type="datetime">
      </mat-datetimepickerT2>

    </mat-form-field>
  </ng-container>
  <ng-container *ngIf="design_pattern == 2">
    <div [ngClass]="{'has-error':form.get([controlName]).hasError('required')||form.get([controlName]).hasError('maxlength')||
      form.get([controlName]).hasError('minlength') ||form.get([controlName]).hasError('max')
      ||form.get([controlName]).hasError('min') || form.get([controlName]).hasError('pattern'),
      'has-success': !form.get([controlName]).hasError('required') && !form.get([controlName]).hasError('maxlength')&&
      !form.get([controlName]).hasError('minlength') && !form.get([controlName]).hasError('max')
                   && !form.get([controlName]).hasError('min') && !form.get([controlName]).hasError('pattern')}"
      class="bootstarp-date">


      <div class="row">
        <div [class]="'col-md-'+(label_width || 12)" *ngIf="label&& !hide_label">
          <label class="design-2-label"
            [ngClass]="label_class && label_class!='' ? ( required ?'req ' + label_class :label_class) :( required ?'req' :'')"
            [ngStyle]="label_css | AddNgStylePipe : {}" [innerHtml]="label | HTMLFormatter"
            [title]="label | HTMLFormatter">
          </label>
        </div>
        <div [class]="'col-md-'+(control_width || 12)">
          <div class="input-group w-100" [ngClass]="control_class && control_class!='' ?control_class:''"
            [ngStyle]="control_css | AddNgStylePipe : {}">
            <input [matDatepicker]="picker" class="form-control bootstrap-input" [min]="minValue" [max]="maxValue"
              [formControl]="date" [placeholder]="placeholder" (dateInput)="addEvent($event)"
              (dateChange)="addEvent($event)" (click)="openPicker(1)">
            <div class="input-group-append">
              <span class="input-group-text py-0 px-2 date-btn">
                <span *ngIf="form && form.get(controlName) && form.get(controlName).value && !required"
                  (click)="removeDate($event)">
                  <i class="fa fa-times mr-1"></i>
                </span>
                <mat-datetimepickerT2-toggle matSuffix [for]="picker" [hidden]="disabled"></mat-datetimepickerT2-toggle>
              </span>
            </div>
            <mat-datetimepickerT2 #picker type="datetime" [multiYearSelector]="true" [twelvehour]="true"
              timeInterval="5" mode="portrait" disabled="false" [hidden]="disabled">
            </mat-datetimepickerT2>
          </div>
        </div>
      </div>

    </div>

  </ng-container>
</form>



<!-- <form [formGroup]="group">
  <mat-form-field>
    <mat-label>Start DateTime</mat-label>
    <mat-datetimepickerT2-toggle [for]="datetimePicker" matSuffix></mat-datetimepickerT2-toggle>
    <mat-datetimepickerT2 #datetimePicker type="datetime" openOnFocus="true" timeInterval="5" mode="portrait"></mat-datetimepickerT2>
    <input matInput formControlName="datetimeCtrl" [matDatetimepickerT2]="datetimePicker" required autocomplete="false">
  </mat-form-field>
</form> -->
